import UsersDatatable from "../../components/UsersDatatable/UsersDatatable";

const Users = () => {
    return (
           <>
            <UsersDatatable></UsersDatatable>
           </>
    );
}

export default Users;